import React from 'react'

import { AssessmentIcon } from '../../atoms/illustrations/AssessmentIcon'
import { ExerciseIcon } from '../../atoms/illustrations/ExerciseIcon'
import { GraduationIcon } from '../../atoms/illustrations/GraduationIcon'
import { InfoSheetIcon } from '../../atoms/illustrations/InfoSheetIcon'
import { LessonIcon } from '../../atoms/illustrations/LessonIcon'
import { PastSessionsIcon } from '../../atoms/illustrations/PastSessionsIcon'
import { SessionsIcon } from '../../atoms/illustrations/SessionsIcon'

export const AssignmentIconSelector: React.FC<AssignmentIconSelectorProps> = ({ type, size = 40 }) => {
  switch (type) {
    case 'lesson':
      return <LessonIcon size={size} />
    case 'exercise':
      return <ExerciseIcon size={size} />
    case 'assessment':
      return <AssessmentIcon size={size} />
    case 'session':
      return <SessionsIcon width={size} />
    case 'infosheet':
      return <InfoSheetIcon size={size} />
    case 'track':
      return <GraduationIcon width={size} />
    default:
      return <PastSessionsIcon width={size} />
  }
}

type AssignmentIconSelectorProps = {
  type: string | undefined
  size?: number
}
